module.exports = __webpack_public_path__ + "img/ysgj_042@2x.0388d47e.png";